import { render, staticRenderFns } from "./CaseLogicLabel.vue?vue&type=template&id=13563331&scoped=true&"
import script from "./CaseLogicLabel.vue?vue&type=script&lang=js&"
export * from "./CaseLogicLabel.vue?vue&type=script&lang=js&"
import style0 from "./CaseLogicLabel.vue?vue&type=style&index=0&id=13563331&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13563331",
  null
  
)

export default component.exports